import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { IconName } from 'Components/frameworks/icon/Icon';
import 'Components/frameworks/icon/Icon';
import { TextSeeMore } from 'Components/frameworks/text-see-more/TextSeeMore';
import { Title } from 'Components/frameworks/title/Title';
import { themes } from './Introduction.themes';
export type IntroductionProps = {
  className?: string;
  dataTestId?: string;
  iconName?: IconName;
  isTextSeeMoreCollapseEnabled?: boolean;
  seeLessLabel?: string;
  seeMoreLabel?: string;
  small?: string;
  subtitle?: string;
  text?: string;
  theme?: keyof typeof themes;
  title?: string;
};
export const Introduction = ({
  className,
  dataTestId,
  iconName,
  isTextSeeMoreCollapseEnabled,
  seeLessLabel,
  seeMoreLabel,
  small,
  subtitle,
  text,
  theme = 'default',
  title,
}: IntroductionProps) => {
  const hasHeading = !!title || !!subtitle;
  const hasText = !!text;

  if (!hasHeading && !hasText) {
    return null;
  }

  const { thLeft, thRight, thRoot, thSmall, thSubtitle, thSubtitleTheme, thTitleTheme } =
    themes[theme];
  return (
    <div className={classnames(thRoot, className)} data-testid={dataTestId}>
      {hasHeading && (
        <div className={thLeft}>
          <Title hLevel={2} iconName={iconName} theme={thTitleTheme}>
            {title}
            {!!small && <small className={thSmall}>{small}</small>}
          </Title>
          <Title className={thSubtitle} hLevel={3} theme={thSubtitleTheme}>
            {subtitle}
          </Title>
        </div>
      )}
      {hasText && (
        <div className={thRight}>
          <TextSeeMore
            isCollapseEnabled={isTextSeeMoreCollapseEnabled}
            seeLessLabel={seeLessLabel}
            seeMoreLabel={seeMoreLabel}
            text={text}
          />
        </div>
      )}
    </div>
  );
};
